import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Recruitment_Process.css";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";

const recruitmentSteps = [
    {
        number: "1",
        title: "Demand Letter",
        description:
            "We evaluate your organization's hiring needs and target requirements.",
    },
    {
        number: "2",
        title: "Employer Verification",
        description:
            "We perform deep verification checks of host employers and job offers.",
    },
    {
        number: "3",
        title: "Candidate Screening",
        description:
            "Candidates undergo rigorous technical evaluations and checks.",
    },
    {
        number: "4",
        title: "Interview Coordination",
        description:
            "Facilitating smooth direct or virtual candidate interviews.",
    },
    {
        number: "5",
        title: "Joining Support",
        description:
            "Assisting in visa stamping, travel ticketing, and orientation.",
    },
];

const RecruitmentProcess = () => {
    return (
        <section className="recruitment_process">
            <Container>
                <div className="process_heading">
                    {/* <h2 className="process_heading-text">Our Recruitment Process</h2> */}
                      <CommonHeading title="Our Recruitment Process" />
                </div>

                <Row className="g-3">
                    {recruitmentSteps.map((step) => (
                        <Col
                            key={step.number}
                            xs={12}
                            md={4}
                            className="process_col"
                        >
                            <div className="process_card">
                                <div className="process_num">
                                    {step.number}
                                </div>

                                <div className="process_content">
                                    <h3 className="process_title">
                                        {step.title}
                                    </h3>

                                    <p className="process_text">
                                        {step.description}
                                    </p>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default RecruitmentProcess;